module.exports = __webpack_public_path__ + "static/media/Cancel.64b686a4.svg";